import {
    ADD_TRIP,
    ADD_TRIP_COMPLETE,
    UPDATE_TRIP,
    DETACH_TRIP_REVIEW,
    DELETE_TRIP,
    GET_TRIPS,
    GET_TRIPS_ERROR,
    GET_TRIP_DETAIL,
    GET_TRIP_DETAIL_ERROR,
    GET_USER_TRIPS,
    ADD_TRIP_ERROR,
} from "../types";

const TripReducer = (state, action) => {
    switch (action.type) {
        case GET_TRIPS: {
            const { items, total, page, pageSize, hasMore, append } = action.payload;
            return {
                ...state,
                trips: append ? [...state.trips, ...items] : items,
                tripsTotal: total,
                tripsPage: page,
                tripsPageSize: pageSize,
                tripsHasMore: hasMore,
                loading: false,
                tripAdded: false,
            };
        }
        case ADD_TRIP:
            return {
                ...state,
                trips: [action.payload, ...state.trips],
                tripsTotal: (state.tripsTotal || 0) + 1,
                loading: false,
                tripAdded: true,
                message: "add_trip_success",
            };
        case ADD_TRIP_COMPLETE:
            return {
                ...state,
                tripAdded: false,
            };
        case UPDATE_TRIP:
            return {
                ...state,
                tripDetail: action.payload,
                trips: state.trips.map((t) => t.id === action.payload.id ? action.payload : t),
                userTrips: state.userTrips.map((t) => t.id === action.payload.id ? action.payload : t),
                loading: false,
            };
        case DETACH_TRIP_REVIEW: {
            const { review_id } = action.payload;
            const detail = state.tripDetail;
            return {
                ...state,
                tripDetail: detail ? {
                    ...detail,
                    spot_reviews: (detail.spot_reviews || []).filter((r) => r.id !== review_id),
                } : detail,
            };
        }
        case DELETE_TRIP:
            return {
                ...state,
                trips: state.trips.filter((t) => t.id !== action.payload),
                userTrips: state.userTrips.filter((t) => t.id !== action.payload),
                tripsTotal: Math.max(0, (state.tripsTotal || 0) - 1),
                userTripsTotal: Math.max(0, (state.userTripsTotal || 0) - 1),
                loading: false,
                message: "delete_trip_success",
            };
        case GET_TRIP_DETAIL: {
            const trip = action.payload;
            return {
                ...state,
                tripDetail: trip,
                loading: false,
                tripAdded: false,
            };
        }
        // Error paths need to clear `loading` too — otherwise a failed
        // fetch leaves the detail page stuck on the loading state forever.
        case GET_TRIP_DETAIL_ERROR:
        case GET_TRIPS_ERROR:
        case ADD_TRIP_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_USER_TRIPS: {
            const { items, total, page, pageSize, hasMore, append } = action.payload;
            return {
                ...state,
                userTrips: append ? [...state.userTrips, ...items] : items,
                userTripsTotal: total,
                userTripsPage: page,
                userTripsPageSize: pageSize,
                userTripsHasMore: hasMore,
                loading: false,
            };
        }
        default:
            return state;
    }
};

export default TripReducer;
